"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _ = require("./");

var _luxon = require("luxon");

class Evaluation {
  static thaw(evaluationObj) {
    if (evaluationObj == null) return null;
    const evaluation = new Evaluation();
    if (evaluationObj.id != null) evaluation.setId(evaluationObj.id);
    if (evaluationObj.scheduledDateTime != null) evaluation.setScheduledDateTime(_luxon.DateTime.fromISO(evaluationObj.scheduledDateTime));
    if (evaluationObj.startTimestamp != null) evaluation.setStartTimestamp(_luxon.DateTime.fromISO(evaluationObj.startTimestamp));
    if (evaluationObj.endTimestamp != null) evaluation.setEndTimestamp(_luxon.DateTime.fromISO(evaluationObj.endTimestamp));
    if (evaluationObj.status != null) evaluation.setStatus(evaluationObj.status);
    if (evaluationObj.heightInInches != null) evaluation.setHeightInInches(evaluationObj.heightInInches);
    if (evaluationObj.whoPays != null) evaluation.setWhoPays(evaluationObj.whoPays);
    if (evaluationObj.segmentId != null) evaluation.setSegmentId(evaluationObj.segmentId);
    if (evaluationObj.evalueeId != null) evaluation.setEvalueeId(evaluationObj.evalueeId);
    if (evaluationObj.evaluatorId != null) evaluation.setEvaluatorId(evaluationObj.evaluatorId);
    if (evaluationObj.groupId != null) evaluation.setGroupId(evaluationObj.GroupId);
    if (evaluationObj.addressId != null) evaluation.setAddressId(evaluationObj.addressId);
    if (evaluationObj.evaluationTransactionId != null) evaluation.setEvaluationTransactionId(evaluationObj.evaluationTransactionId);
    if (evaluationObj.serviceTransactionId != null) evaluation.setServiceTransactionId(evaluationObj.serviceTransactionId);
    if (evaluationObj.evaluationRequestEvalueeId != null) evaluation.setEvaluationRequestEvalueeId(evaluationObj.evaluationRequestEvalueeId);
    if (evaluationObj.evaluatorGivenReviewId != null) evaluation.setEvaluatorGivenReviewId(evaluationObj.evaluatorGivenReviewId);
    if (evaluationObj.evalueeGivenReviewId != null) evaluation.setEvalueeGivenReviewId(evaluationObj.evalueeGivenReviewId);
    if (evaluationObj.evaluationRequestId != null) evaluation.setEvaluationRequestId(evaluationObj.evaluationRequestId);
    if (evaluationObj.segment != null) evaluation.setSegment(_.ErgoAlgoSegment.thaw(evaluationObj.segment));
    if (evaluationObj.evaluee != null) evaluation.setEvaluee(_.Person.thaw(evaluationObj.evaluee));
    if (evaluationObj.evaluator != null) evaluation.setEvaluator(_.Person.thaw(evaluationObj.evaluator));
    if (evaluationObj.group != null) evaluation.setGroup(_.Group.thaw(evaluationObj.group));
    if (evaluationObj.address != null) evaluation.setAddress(_.Address.thaw(evaluationObj.address));
    if (evaluationObj.evaluationTransaction != null) evaluation.setEvaluationTransaction(_.Transaction.thaw(evaluationObj.evaluationTransaction));
    if (evaluationObj.serviceTransaction != null) evaluation.setServiceTransaction(_.Transaction.thaw(evaluationObj.serviceTransaction));
    if (evaluationObj.sectionAnswers != null) evaluation.setSectionAnswers(_.EvaluationSectionAnswer.thawList(evaluationObj.sectionAnswers));
    if (evaluationObj.evaluationRequesEvaluee != null) evaluation.setEvaluationRequesEvaluee(_.EvaluationRequestEvaluee.thaw(evaluationObj.evaluationRequesEvaluee));
    if (evaluationObj.evaluatorGivenReview != null) evaluation.setEvaluatorGivenReview(_.Review.thaw(evaluationObj.evaluatorGivenReview));
    if (evaluationObj.evalueeGivenReview != null) evaluation.setEvalueeGivenReview(_.Review.thaw(evaluationObj.evalueeGivenReview));
    if (evaluationObj.evaluationRequest != null) evaluation.setEvaluationRequest(_.EvaluationRequest.thaw(evaluationObj.evaluationRequest));
    if (evaluationObj.notes != null) evaluation.setNotes(evaluationObj.notes);
    if (evaluationObj.privateNotes != null) evaluation.setPrivateNotes(evaluationObj.privateNotes);
    if (evaluationObj.evalueeComplaints != null) evaluation.setEvalueeComplaints(evaluationObj.evalueeComplaints);
    if (evaluationObj.beforePhotoPaths != null) evaluation.setBeforePhotoPaths(evaluationObj.beforePhotoPaths);
    if (evaluationObj.afterPhotoPaths != null) evaluation.setAfterPhotoPaths(evaluationObj.afterPhotoPaths);
    if (evaluationObj.evaluationVersionId != null) evaluation.setEvaluationVersionId(evaluationObj.evaluationVersionId);
    if (evaluationObj.reportUrl != null) evaluation.setReportUrl(evaluationObj.reportUrl);
    if (evaluationObj.evalueeCanViewReport != null) evaluation.setEvalueeCanViewReport(evaluationObj.evalueeCanViewReport);
    if (evaluationObj.isPaid != null) evaluation.setIsPaid(evaluationObj.isPaid);
    return evaluation;
  }

  static thawList(evaluationObjList) {
    if (evaluationObjList == null) return [];
    var evaluations = [];

    for (var i = 0; i < evaluationObjList.length; i++) {
      evaluations.push(Evaluation.thaw(evaluationObjList[i]));
    }

    return evaluations;
  }

  static freeze(evaluation) {
    if (evaluation == null) return null;
    var evaluationObj = {};
    if (evaluation.getId() != null) evaluationObj.id = evaluation.getId();
    if (evaluation.getScheduledDateTime() != null) evaluationObj.scheduledDateTime = evaluation.getScheduledDateTime();
    if (evaluation.getStartTimestamp() != null) evaluationObj.startTimestamp = evaluation.getStartTimestamp();
    if (evaluation.getEndTimestamp() != null) evaluationObj.endTimestamp = evaluation.getEndTimestamp();
    if (evaluation.getStatus() != null) evaluationObj.status = evaluation.getStatus();
    if (evaluation.getHeightInInches() != null) evaluationObj.heightInInches = evaluation.getHeightInInches();
    if (evaluation.getWhoPays() != null) evaluationObj.whoPays = evaluation.getWhoPays();
    if (evaluation.getSegmentId() != null) evaluationObj.segmentId = evaluation.getSegmentId();
    if (evaluation.getEvalueeId() != null) evaluationObj.evalueeId = evaluation.getEvalueeId();
    if (evaluation.getEvaluatorId() != null) evaluationObj.evaluatorId = evaluation.getEvaluatorId();
    if (evaluation.getGroupId() != null) evaluationObj.groupId = evaluation.getGroupId();
    if (evaluation.getAddressId() != null) evaluationObj.addressId = evaluation.getAddressId();
    if (evaluation.getEvaluationTransactionId() != null) evaluationObj.evaluationTransactionId = evaluation.getEvaluationTransactionId();
    if (evaluation.getServiceTransactionId() != null) evaluationObj.serviceTransactionId = evaluation.getServiceTransactionId();
    if (evaluation.getEvaluationRequestEvalueeId() != null) evaluationObj.evaluationRequestEvalueeId = evaluation.getEvaluationRequestEvalueeId();
    if (evaluation.getEvaluatorGivenReviewId() != null) evaluationObj.evaluatorGivenReviewId = evaluation.getEvaluatorGivenReviewId();
    if (evaluation.getEvalueeGivenReviewId() != null) evaluationObj.evalueeGivenReviewId = evaluation.getEvalueeGivenReviewId();
    if (evaluation.getEvaluationRequestId() != null) evaluationObj.evaluationRequestId = evaluation.getEvaluationRequestId();
    if (evaluation.getSegment() != null) evaluationObj.segment = _.ErgoAlgoSegment.freeze(evaluation.getSegment());
    if (evaluation.getEvaluee() != null) evaluationObj.evaluee = _.Person.freeze(evaluation.getEvaluee());
    if (evaluation.getEvaluator() != null) evaluationObj.evaluator = _.Person.freeze(evaluation.getEvaluator());
    if (evaluation.getGroup() != null) evaluationObj.group = _.Group.freeze(evaluation.getGroup());
    if (evaluation.getAddress() != null) evaluationObj.address = _.Address.freeze(evaluation.getAddress());
    if (evaluation.getEvaluationTransaction() != null) evaluationObj.evaluationTransaction = _.Transaction.freeze(evaluation.getEvaluationTransaction());
    if (evaluation.getServiceTransaction() != null) evaluationObj.serviceTransaction = _.Transaction.freeze(evaluation.getServiceTransaction());
    if (evaluation.getSectionAnswers() != null) evaluationObj.sectionAnswers = _.EvaluationSectionAnswer.freezeList(evaluation.getSectionAnswers());
    if (evaluation.getEvaluationRequesEvaluee() != null) evaluationObj.evaluationRequesEvaluee = _.EvaluationRequestEvaluee.freeze(evaluation.getEvaluationRequesEvaluee());
    if (evaluation.getEvaluatorGivenReview() != null) evaluationObj.evaluatorGivenReview = _.Review.freeze(evaluation.getEvaluatorGivenReview());
    if (evaluation.getEvalueeGivenReview() != null) evaluationObj.evalueeGivenReview = _.Review.freeze(evaluation.getEvalueeGivenReview());
    if (evaluation.getEvaluationRequest() != null) evaluationObj.evaluationRequest = _.EvaluationRequest.freeze(evaluation.getEvaluationRequest());
    if (evaluation.getNotes() != null) evaluationObj.notes = evaluation.getNotes();
    if (evaluation.getPrivateNotes() != null) evaluationObj.privateNotes = evaluation.getPrivateNotes();
    if (evaluation.getEvalueeComplaints() != null) evaluationObj.evalueeComplaints = evaluation.getEvalueeComplaints();
    if (evaluation.getBeforePhotoPaths() != null) evaluationObj.beforePhotoPaths = evaluation.getBeforePhotoPaths();
    if (evaluation.getAfterPhotoPaths() != null) evaluationObj.afterPhotoPaths = evaluation.getAfterPhotoPaths();
    if (evaluation.getEvaluationVersionId() != null) evaluationObj.evaluationVersionId = evaluation.getEvaluationVersionId();
    if (evaluation.getEvalueeCanViewReport() != null) evaluationObj.evalueeCanViewReport = evaluation.getEvalueeCanViewReport();
    if (evaluation.getIsPaid() != null) evaluationObj.isPaid = evaluation.getIsPaid();
    return evaluationObj;
  }

  static freezeList(evaluations) {
    if (evaluations == null) return [];
    var evaluationObjList = [];

    for (var i = 0; i < evaluations.length; i++) {
      evaluationObjList.push(Evaluation.freeze(evaluations[i]));
    }

    return evaluationObjList;
  }

  constructor() {
    this.setId(null);
    this.setScheduledDateTime(null);
    this.setStartTimestamp(null);
    this.setEndTimestamp(null);
    this.setStatus(null);
    this.setHeightInInches(null);
    this.setWhoPays(null);
    this.setSegmentId(null);
    this.setEvalueeId(null);
    this.setEvaluatorId(null);
    this.setGroupId(null);
    this.setAddressId(null);
    this.setEvaluationTransactionId(null);
    this.setServiceTransactionId(null);
    this.setEvaluationRequestEvalueeId(null);
    this.setEvaluatorGivenReviewId(null);
    this.setEvalueeGivenReviewId(null);
    this.setEvaluationRequestId(null);
    this.setSegment(null);
    this.setEvaluee(null);
    this.setEvaluator(null);
    this.setGroup(null);
    this.setAddress(null);
    this.setEvaluationTransaction(null);
    this.setServiceTransaction(null);
    this.setSectionAnswers(null);
    this.setEvaluationRequesEvaluee(null);
    this.setEvaluatorGivenReview(null);
    this.setEvalueeGivenReview(null);
    this.setEvaluationRequest(null);
    this.setNotes(null);
    this.setPrivateNotes(null);
    this.setEvalueeComplaints(null);
    this.setBeforePhotoPaths(null);
    this.setAfterPhotoPaths(null);
    this.setEvaluationVersionId(null);
    this.setReportUrl(null);
    this.setEvalueeCanViewReport(null);
    this.setIsPaid(null);
  }
  /* -------------------------
     -------------------------
     -------- SETTERS --------
     -------------------------
     ------------------------- */


  setId(id) {
    this.id = id;
  }

  setScheduledDateTime(scheduledDateTime) {
    this.scheduledDateTime = scheduledDateTime;
  }

  setStartTimestamp(startTimestamp) {
    this.startTimestamp = startTimestamp;
  }

  setEndTimestamp(endTimestamp) {
    this.endTimestamp = endTimestamp;
  }

  setStatus(status) {
    this.status = status;
  }

  setHeightInInches(heightInInches) {
    this.heightInInches = heightInInches;
  }

  setWhoPays(whoPays) {
    this.whoPays = whoPays;
  }

  setSegmentId(segmentId) {
    this.segmentId = segmentId;
  }

  setEvalueeId(evalueeId) {
    this.evalueeId = evalueeId;
  }

  setEvaluatorId(evaluatorId) {
    this.evaluatorId = evaluatorId;
  }

  setGroupId(groupId) {
    this.groupId = groupId;
  }

  setAddressId(addressId) {
    this.addressId = addressId;
  }

  setEvaluationTransactionId(evaluationTransactionId) {
    this.evaluationTransactionId = evaluationTransactionId;
  }

  setServiceTransactionId(serviceTransactionId) {
    this.serviceTransactionId = serviceTransactionId;
  }

  setEvaluationRequestEvalueeId(evaluationRequestEvalueeId) {
    this.evaluationRequestEvalueeId = evaluationRequestEvalueeId;
  }

  setEvaluatorGivenReviewId(evaluatorGivenReviewId) {
    this.evaluatorGivenReviewId = evaluatorGivenReviewId;
  }

  setEvalueeGivenReviewId(evalueeGivenReviewId) {
    this.evalueeGivenReviewId = evalueeGivenReviewId;
  }

  setEvaluationRequestId(evaluationRequestId) {
    this.evaluationRequestId = evaluationRequestId;
  }

  setSegment(segment) {
    this.segment = segment;
  }

  setEvaluee(evaluee) {
    this.evaluee = evaluee;
  }

  setEvaluator(evaluator) {
    this.evaluator = evaluator;
  }

  setGroup(group) {
    this.group = group;
  }

  setAddress(address) {
    this.address = address;
  }

  setEvaluationTransaction(evaluationTransaction) {
    this.evaluationTransaction = evaluationTransaction;
  }

  setServiceTransaction(serviceTransaction) {
    this.serviceTransaction = serviceTransaction;
  }

  setSectionAnswers(sectionAnswers) {
    this.sectionAnswers = sectionAnswers;
  }

  setEvaluationRequesEvaluee(evaluationRequesEvaluee) {
    this.evaluationRequesEvaluee = evaluationRequesEvaluee;
  }

  setEvaluatorGivenReview(evaluatorGivenReview) {
    this.evaluatorGivenReview = evaluatorGivenReview;
  }

  setEvalueeGivenReview(evalueeGivenReview) {
    this.evalueeGivenReview = evalueeGivenReview;
  }

  setEvaluationRequest(evaluationRequest) {
    this.evaluationRequest = evaluationRequest;
  }

  setNotes(notes) {
    this.notes = notes;
  }

  setPrivateNotes(privateNotes) {
    this.privateNotes = privateNotes;
  }

  setEvalueeComplaints(evalueeComplaints) {
    this.evalueeComplaints = evalueeComplaints;
  }

  setBeforePhotoPaths(beforePhotoPaths) {
    this.beforePhotoPaths = beforePhotoPaths;
  }

  setAfterPhotoPaths(afterPhotoPaths) {
    this.afterPhotoPaths = afterPhotoPaths;
  }

  setEvaluationVersionId(evaluationVersionId) {
    this.evaluationVersionId = evaluationVersionId;
  }

  setReportUrl(reportUrl) {
    this.reportUrl = reportUrl;
  }

  setEvalueeCanViewReport(evalueeCanViewReport) {
    this.evalueeCanViewReport = evalueeCanViewReport;
  }

  setIsPaid(isPaid) {
    this.isPaid = isPaid;
  }
  /* -------------------------
     -------------------------
     -------- GETTERS --------
     -------------------------
     ------------------------- */


  getId() {
    return this.id;
  }

  getScheduledDateTime() {
    return this.scheduledDateTime;
  }

  getStartTimestamp() {
    return this.startTimestamp;
  }

  getEndTimestamp() {
    return this.endTimestamp;
  }

  getStatus() {
    return this.status;
  }

  getHeightInInches() {
    return this.heightInInches;
  }

  getWhoPays() {
    return this.whoPays;
  }

  getSegmentId() {
    return this.segmentId;
  }

  getEvalueeId() {
    return this.evalueeId;
  }

  getEvaluatorId() {
    return this.evaluatorId;
  }

  getGroupId() {
    return this.groupId;
  }

  getAddressId() {
    return this.addressId;
  }

  getEvaluationTransactionId() {
    return this.evaluationTransactionId;
  }

  getServiceTransactionId() {
    return this.serviceTransactionId;
  }

  getEvaluationRequestEvalueeId() {
    return this.evaluationRequestEvalueeId;
  }

  getEvaluatorGivenReviewId() {
    return this.evaluatorGivenReviewId;
  }

  getEvalueeGivenReviewId() {
    return this.evalueeGivenReviewId;
  }

  getEvaluationRequestId() {
    return this.evaluationRequestId;
  }

  getSegment() {
    return this.segment;
  }

  getEvaluee() {
    return this.evaluee;
  }

  getEvaluator() {
    return this.evaluator;
  }

  getGroup() {
    return this.group;
  }

  getAddress() {
    return this.address;
  }

  getEvaluationTransaction() {
    return this.evaluationTransaction;
  }

  getServiceTransaction() {
    return this.serviceTransaction;
  }

  getSectionAnswers() {
    return this.sectionAnswers;
  }

  getEvaluationRequesEvaluee() {
    return this.evaluationRequesEvaluee;
  }

  getEvaluatorGivenReview() {
    return this.evaluatorGivenReview;
  }

  getEvalueeGivenReview() {
    return this.evalueeGivenReview;
  }

  getEvaluationRequest() {
    return this.evaluationRequest;
  }

  getNotes() {
    return this.notes;
  }

  getPrivateNotes() {
    return this.privateNotes;
  }

  getEvalueeComplaints() {
    return this.evalueeComplaints;
  }

  getBeforePhotoPaths() {
    return this.beforePhotoPaths;
  }

  getAfterPhotoPaths() {
    return this.afterPhotoPaths;
  }

  getEvaluationVersionId() {
    return this.evaluationVersionId;
  }

  getReportUrl() {
    return this.reportUrl;
  }

  getEvalueeCanViewReport() {
    return this.evalueeCanViewReport;
  }

  getIsPaid() {
    return this.isPaid;
  }
  /* -------------------------
     -------------------------
     -------- HELPERS --------
     -------------------------
     ------------------------- */


  areRisksAddressed() {
    var _this$sectionAnswers;

    let risksAddressed = true;
    (_this$sectionAnswers = this.sectionAnswers) === null || _this$sectionAnswers === void 0 ? void 0 : _this$sectionAnswers.forEach(sectionAnswer => {
      if (!sectionAnswer.areRisksAddressed()) risksAddressed = false;
    });
    return risksAddressed;
  }

  isComplete() {
    return this.status === 'COMPLETED';
  }

}

exports.default = Evaluation;